<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        {{title}}
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHome()" >
         <van-icon name="manager" size="21"/>
      </div>
    </div>
    <div class="padding content">
      <van-loading size="24px" v-show="showL" style="text-align:center">加载中...</van-loading>
      <div
        class="list"
        v-for="(item,index) in info"
        :key="index"
        @click="toGuide(item.id,item.has_submenu,item.title)"
      >{{item.title}}</div>
    </div>
  </div>
</template>
<script>
import { Icon, Field ,Loading} from "vant";
import { wantMenu } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Loading.name]: Loading,
  },
  data() {
    return {
      info: [],
      type: "",
      showL:true,
      title:''
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let id = this.$route.query.id;
    let title = this.$route.query.title;
    this.title = title
    this.getIntro(id);
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome(){
      this.$router.push('/mine');
    },
    getIntro(id) {
      wantMenu({ index_id: id }).then((res) => {
        this.info = res.data;
        this.showL = false
      });
    },
    toGuide(id, h,t) {
      // console.log(888)
      if (h == 1) {
        this.$router.push({
          path: "/wantGuide",
          query: {
            id: id,
            title:t
          },
        });
      }else{
          this.$router.push({
          path: "/wantInfo",
          query: {
            id: id,
            title:t
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
</style>


// WEBPACK FOOTER //
// src/page/wantMenu.vue